import { render, staticRenderFns } from "./dr-launcher-component.vue?vue&type=template&id=09e33f2e&"
import script from "./dr-launcher-component.vue?vue&type=script&lang=js&"
export * from "./dr-launcher-component.vue?vue&type=script&lang=js&"
import style0 from "./dr-launcher-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports